module.exports = {
  login: 'login',
  registration: 'registration',
  registrationVerify: 'verify',
  resetPassword: 'reset-password',
  setNewPassword: 'set-new-password',
};
